import React from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import Inline from '@atlaskit/primitives/inline';
import { xcss } from '@atlaskit/primitives/xcss';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import LinkButton from '@atlaskit/button/link';
import { token } from '@atlaskit/tokens';
import { RovoIcon } from '@atlaskit/logo';

import { messages } from '../../messages.ts';

const aiSubFooterWrapperStyle = xcss({
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	borderTopWidth: 'border.width',
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
});

const textColorStyle = xcss({
	paddingTop: 'space.025',
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});

export const AiSubFooter = (): React.JSX.Element => (
	<Box xcss={aiSubFooterWrapperStyle}>
		<Inline alignInline="center" alignBlock="center">
			<LinkButton
				appearance="subtle"
				spacing="compact"
				iconBefore={(iconProps) => (
					<StatusInformationIcon
						{...iconProps}
						color={token('color.text.subtlest')}
						spacing="none"
					/>
				)}
				href="https://www.atlassian.com/trust/atlassian-intelligence"
				rel="noopener"
				target="_blank"
				testId="issue-create-side-panel.ai-footer.disclaimer-text"
			>
				<Box xcss={textColorStyle}>
					<FormattedMessage {...messages.sidePanelFooterDisclaimerText} />
				</Box>
			</LinkButton>
			<LinkButton
				appearance="subtle"
				spacing="compact"
				iconAfter={(iconProps) => <RovoIcon {...iconProps} appearance="brand" size="xsmall" />}
				href="https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/"
				rel="noopener"
				target="_blank"
				testId="issue-create-side-panel.ai-footer.powered-by-rovo-text"
			>
				<Box xcss={textColorStyle}>
					<FormattedMessage {...messages.sidePanelFooterRovoText} />
				</Box>
			</LinkButton>
		</Inline>
	</Box>
);
